import React from 'react'
import {useTranslation} from 'react-i18next'
import AnchorModal, {TinyModalContent} from '../../../Molecules/Modals/AnchorModal'
import {Baseline} from '../../../Layout/Grid'
import {IconButton} from '../../../Atoms/Buttons'

interface LocationSettingProps {
  isOpen: boolean
  isSuperUser: boolean
  mainUser: boolean
  onClose: () => void
  onSiteAdd: () => void
  onLocationAdd: () => void
  onMultipleSiteClosingPeriod: () => void
  onPublicHolidayClosingPeriod: () => void
  onSiteAddForLocation: () => void
  onExportSiteDetails: () => void
}
const LocationsMenuModal = ({
  isOpen,
  isSuperUser,
  mainUser,
  onClose,
  onSiteAdd,
  onLocationAdd,
  onMultipleSiteClosingPeriod,
  onPublicHolidayClosingPeriod,
  onSiteAddForLocation,
  onExportSiteDetails
}: LocationSettingProps) => {
  const {t} = useTranslation('locations')

  return (
    <>
      <AnchorModal anchorMode={'right'} isOpen={isOpen} onClose={onClose}>
        <TinyModalContent data-cy="location-menu-modal">
          <Baseline>
            {isSuperUser && (
              <IconButton
                description={t('locations:actions.addSite', 'Add Site')}
                buttonProps={{onClick: () => onSiteAdd()}}
              />
            )}

            {isSuperUser && (
              <IconButton
                description={t('locations:actions.Add Location', 'Add Location')}
                buttonProps={{
                  onClick: () => onLocationAdd()
                }}
              />
            )}

            {(isSuperUser || mainUser) && (
              <IconButton
                description={t('locations:actions.addMultipleSiteClosing', 'Add Multiple site closing period')}
                buttonProps={{
                  onClick: () => onMultipleSiteClosingPeriod()
                }}
              />
            )}

            {(isSuperUser || mainUser) && (
              <IconButton
                description={t(
                  'locations:actions.addPublicHolidaySiteClosing',
                  'Add site closing period for public holidays'
                )}
                buttonProps={{
                  onClick: () => onPublicHolidayClosingPeriod()
                }}
              />
            )}

            {isSuperUser && (
              <IconButton
                description={t('locations:actions.addSitesForLocation', 'Add Multiple Sites for Location')}
                buttonProps={{
                  onClick: () => onSiteAddForLocation()
                }}
              />
            )}

            {isSuperUser && (
              <IconButton
                description={t('locations:actions.exportSiteDetails', 'Export Site Detail(s)')}
                buttonProps={{
                  onClick: () => onExportSiteDetails()
                }}
              />
            )}
          </Baseline>
        </TinyModalContent>
      </AnchorModal>
    </>
  )
}

export default LocationsMenuModal
